<template>
    <b-modal
        ref="modalFilterEngagedReport"
        lazy
        title-tag="h2"
        :title="title"
        no-close-on-esc
        no-close-on-backdrop
        no-enforce-focus
    >
        <div v-if="!isLoaded">
            <img src="assets/ajax-loader.gif" style="padding: 10px;" />
        </div>
        <b-form-group v-else label-for="period" label-cols="4" label="As Of:">
            <date-picker
                v-validate="'required'"
                :config="datePickerOptions"
                :class="{ 'border-danger': errors.has('periodEnd') }"
                name="periodEnd"
                v-model="periodEnd"
            ></date-picker>
        </b-form-group>

        <b-form-group label-for="period" label-cols="4" label="Range Period:">
            <b-select v-model="period">
                <option value="18">
                    18 Months
                </option>
                <option value="24">
                    24 Months
                </option>
            </b-select>
        </b-form-group>

        <b-form-group
            v-if="isRecordSharing"
            label-for="homeLocation"
            label-cols="4"
            label="Home Location:"
        >
            <b-select v-model="homeLocation">
                <option value="" selected>
                    All Location
                </option>
                <option
                    v-for="location in homeLocations"
                    :key="location.id"
                    :value="location.id"
                >
                    {{ location.name }}
                </option>
            </b-select>
        </b-form-group>

        <template v-slot:modal-footer="{ cancel }">
            <b-button class="mr-auto" variant="secondary" @click="cancel">
                Cancel
            </b-button>

            <b-button variant="primary" @click="submit">
                Generate Report
            </b-button>
        </template>
    </b-modal>
</template>

<script>
import { DateTime } from "luxon";
import CREPORT from "@/constants/report";

export default {
    props: {
        data: {
            type: Object,
            default() {
                return {
                    home_location_id: null,
                    interval_month: null,
                    period: null
                };
            }
        }
    },
    data() {
        return {
            title: "Filter Report",
            datePickerOptions: {
                format: null,
                timeZone: ""
            },
            period: "18",
            periodStart: null,
            periodEnd: null,
            homeLocation: ""
        };
    },
    computed: {
        isLoaded() {
            return this.$root.setting.id != undefined;
        },
        isRecordSharing() {
            return this.$root.setting.isRecordSharing ?? false;
        },
        homeLocations() {
            return this.$root.setting.listGroupBusiness ?? [];
        },
        to() {
            return DateTime.fromFormat(this.periodEnd, this._dateFormat);
        },
        from() {
            const end = DateTime.fromFormat(
                this.periodEnd,
                this._getLuxonFormat()
            );
            return end.minus({ months: this.period });
        }
    },
    watch: {
        isLoaded(oldVal, newVal) {
            // wait until this.$root.setting exist before initialize form
            if (newVal || oldVal) {
                this.initDatePicker();
            }
        }
    },
    methods: {
        open() {
            this.initDatePicker();
            this.$refs.modalFilterEngagedReport.show();
        },
        async submit() {
            try {
                const params = {
                    from: this.from.toSeconds(),
                    to: this.to.toSeconds(),
                    interval_month: Number(this.period),
                    home_location_id: this.homeLocation,
                    home_location: this.homeLocations.find(
                        e => e.id == this.homeLocation
                    )
                };

                // eslint-disable-next-line vue/custom-event-name-casing
                switch (parseInt(this.$route.params.id)) {
                    case CREPORT.TYPE.ACTIVE_ENGAGED_PATIENT:
                        this.$root.$emit("active_engaged_patient:load", params);
                        break;
                    case CREPORT.TYPE.ACTIVE_ENGAGED_CLIENT_LIST:
                        this.$root.$emit("active_engaged_client_list:load", params);
                        break;
                }

                this.$refs.modalFilterEngagedReport.hide();
            } catch (error) {
                this._message(error.message, "danger");
            }
        },
        initDatePicker() {
            let dt = DateTime.local().setZone(this._timeZone);
            this.datePickerOptions.timeZone = this._timeZone;
            this.datePickerOptions.format = this._getDateFormat();
            this.periodEnd = dt.toFormat(this._dateFormat);

            // start assign input v-model based on data prop
            const periodEndData = this.data.to
                ? DateTime.fromSeconds(this.data.to)
                : null;

            this.homeLocation = this.data.home_location_id
                ? this.data.home_location_id
                : this.homeLocation;

            this.period = this.data.interval_month
                ? this.data.interval_month
                : this.period;

            this.periodEnd = periodEndData
                ? periodEndData.toFormat(this._dateFormat)
                : this.periodEnd;
        }
    }
};
</script>
